export default __webpack_public_path__ + "static/media/Snd_BigLineDown.e23464a7.mp3";